// extracted by mini-css-extract-plugin
export default {"shippingError":"_c6ad5492"};